export default {

  namespaced: true,

  state: () => ({

    purchases: {}

  }),

  mutations: {

    setPurchases(state, data) {

      state.purchases = data

    }

  },

  actions: {

    async getPurchases({ dispatch, commit }, params) {

      await axios.get('/erp/purchase/purchase', { params })
        .then(response => {

          commit('setPurchases', response.data.purchase);

        }).catch(error => {

          console.log(error)

        })

    },

    async getPurchase({ dispatch, commit }, id) {

      return await axios.get('/erp/purchase/purchase/' + id)
        .then(response => {
          console.log('response', response.data)

          return response.data
          //commit('setPurchases', response.data.purchase);

        }).catch(error => {

          console.log(error)

        })

    },

    async getParsedXml({ dispatch }, params) {

      const data = await axios.post('/erp/purchase/parse-xml', params);

      return data;

    },

    async getPurchaseHasRegistered({ dispatch }, params) {

      const data = await axios.get('/erp/purchase/purchase', { params });

      return data;

    },

    async postPurchase({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/erp/purchase/purchase', params)
          .then((response) => {
            resolve(response.data)

          }).catch(error => {
            reject(error)
          });
      });
    },

    async postEmitPurchaseStockTransaction({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        axios.post('/erp/purchase/emit-purchase-stock-transaction', params)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },


    async postEmitPurchaseBill({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        axios.post('/erp/purchase/emit-purchase-bill', params)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async deletePurchase({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('/erp/purchase/purchase/' + id)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async getPurchasesReport({ dispatch }, params) {

      const data = await axios.get('/erp/purchase/purchase-report', { params: params });

      return data;
    }
  }
}
